import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl pb-56" }
const _hoisted_3 = { class: "text-gray-900 text-4xl font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "mt-6 bg-white border border-gray-200 shadow-sm p-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between"
}
const _hoisted_5 = { class: "text-gray-900 text-lg font-semibold flex items-center gap-2" }
const _hoisted_6 = {
  key: 1,
  class: "grid gap-4 mt-6 md:grid-cols-3"
}
const _hoisted_7 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-4" }
const _hoisted_8 = { class: "flex items-center gap-2 text-xs uppercase tracking-wide text-gray-500" }
const _hoisted_9 = { class: "text-2xl font-semibold text-gray-900 mt-1" }
const _hoisted_10 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-4" }
const _hoisted_11 = { class: "flex items-center gap-2 text-xs uppercase tracking-wide text-gray-500" }
const _hoisted_12 = { class: "text-2xl font-semibold text-gray-900 mt-1" }
const _hoisted_13 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-4" }
const _hoisted_14 = { class: "flex items-center gap-2 text-xs uppercase tracking-wide text-gray-500" }
const _hoisted_15 = { class: "text-2xl font-semibold text-gray-900 mt-1" }
const _hoisted_16 = {
  key: 2,
  class: "mt-10 bg-white border border-gray-200 shadow-sm p-6"
}
const _hoisted_17 = { class: "md:col-span-2" }
const _hoisted_18 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "md:col-span-2" }
const _hoisted_21 = { class: "flex flex-wrap gap-4" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "md:col-span-2 flex items-center gap-3" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_26 = { class: "grid gap-6 mt-10 md:grid-cols-2" }
const _hoisted_27 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5" }
const _hoisted_28 = { class: "flex items-center justify-between mb-3" }
const _hoisted_29 = { class: "text-gray-900 text-lg font-medium flex items-center gap-2" }
const _hoisted_30 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_31 = {
  key: 1,
  class: "space-y-3 text-sm text-gray-700"
}
const _hoisted_32 = { class: "text-gray-600" }
const _hoisted_33 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5" }
const _hoisted_34 = { class: "flex items-center justify-between mb-3" }
const _hoisted_35 = { class: "text-gray-900 text-lg font-medium flex items-center gap-2" }
const _hoisted_36 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_37 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_38 = { class: "mt-1 flex items-start justify-between gap-4" }
const _hoisted_39 = { class: "text-xs text-gray-600" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_42 = { class: "text-xs text-gray-600" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "text-right text-sm font-semibold text-gray-900" }
const _hoisted_45 = {
  key: 3,
  class: "grid gap-6 mt-10 md:grid-cols-2"
}
const _hoisted_46 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5" }
const _hoisted_47 = { class: "flex items-center justify-between mb-3" }
const _hoisted_48 = { class: "text-gray-900 text-lg font-medium flex items-center gap-2" }
const _hoisted_49 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_50 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_51 = { class: "flex items-center gap-3" }
const _hoisted_52 = { class: "flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-700" }
const _hoisted_53 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_54 = { class: "text-xs text-gray-600" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-5" }
const _hoisted_57 = { class: "flex items-center justify-between mb-3" }
const _hoisted_58 = { class: "text-gray-900 text-lg font-medium flex items-center gap-2" }
const _hoisted_59 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_60 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_61 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_62 = { class: "text-xs text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SparklesIcon = _resolveComponent("SparklesIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_CalendarDaysIcon = _resolveComponent("CalendarDaysIcon")!
  const _component_AcademicCapIcon = _resolveComponent("AcademicCapIcon")!
  const _component_MegaphoneIcon = _resolveComponent("MegaphoneIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_TicketIcon = _resolveComponent("TicketIcon")!
  const _component_UserGroupIcon = _resolveComponent("UserGroupIcon")!
  const _component_UserPlusIcon = _resolveComponent("UserPlusIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_BookOpenIcon = _resolveComponent("BookOpenIcon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, " Welcome " + _toDisplayString(_ctx.user?.fullName) + "! ", 1),
      _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-gray-600 text-sm mt-2" }, " Your network, updates, and learning in one place. ", -1)),
      (!_ctx.isCommunityPlus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_5, [
                _createVNode(_component_SparklesIcon, { class: "h-5 w-5 text-primary" }),
                _cache[3] || (_cache[3] = _createTextVNode(" Upgrade to Community Plus "))
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, " Unlock the Academy and Member Directory with Community Plus. ", -1))
            ]),
            _createVNode(_component_router_link, {
              class: "inline-flex items-center justify-center rounded-full border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100",
              to: "/dashboard/account"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Upgrade ")
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCommunityPlus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_UsersIcon, { class: "h-4 w-4 text-gray-400" }),
                _cache[6] || (_cache[6] = _createTextVNode(" Total Members "))
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.users.length), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CalendarDaysIcon, { class: "h-4 w-4 text-gray-400" }),
                _cache[7] || (_cache[7] = _createTextVNode(" Upcoming Events "))
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.upcomingEvents.length), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_AcademicCapIcon, { class: "h-4 w-4 text-gray-400" }),
                _cache[8] || (_cache[8] = _createTextVNode(" Courses Available "))
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.courses.length), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSetup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-gray-900 text-2xl font-semibold" }, " Setup Account ", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-gray-600 mt-2" }, " To get started, please set up your account by providing all the required information. ", -1)),
            _createElementVNode("form", {
              class: "mt-6 grid gap-6 md:grid-cols-2",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSetup && _ctx.saveSetup(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-3" }, " Which VNTR offerings appeal to you? * ", -1)),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offeringsOptions, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option,
                      class: "flex items-center gap-2 text-sm text-gray-700"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOfferings) = $event)),
                        class: "h-4 w-4 rounded border-gray-300",
                        type: "checkbox",
                        value: option
                      }, null, 8, _hoisted_19), [
                        [_vModelCheckbox, _ctx.selectedOfferings]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-3" }, " How would you describe yourself? * ", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option,
                      class: "flex items-center gap-2 text-sm text-gray-700"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.persona) = $event)),
                        class: "h-4 w-4 border-gray-300",
                        type: "radio",
                        value: option
                      }, null, 8, _hoisted_22), [
                        [_vModelRadio, _ctx.persona]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "inline-flex items-center rounded-lg bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800 disabled:opacity-50",
                  type: "submit",
                  disabled: !_ctx.canSaveSetup
                }, " Save Setup ", 8, _hoisted_24),
                (_ctx.setupError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.setupError), 1))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h3", _hoisted_29, [
              _createVNode(_component_MegaphoneIcon, { class: "h-5 w-5 text-primary" }),
              _cache[13] || (_cache[13] = _createTextVNode(" Announcements "))
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Latest", -1))
          ]),
          (_ctx.announcements.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, " No announcements yet. "))
            : (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements.slice(0, 3), (announcement) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: announcement._id,
                    class: "border-l-2 border-primary pl-3"
                  }, [
                    _createVNode(_component_router_link, {
                      class: "font-medium text-gray-900 hover:text-primary",
                      to: `/dashboard/announcements/${announcement._id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(announcement.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(announcement.body), 1),
                    _createVNode(_component_router_link, {
                      class: "inline-flex items-center mt-2 text-xs font-medium text-gray-900 border border-gray-300 rounded-full px-3 py-1 hover:bg-gray-100",
                      to: `/dashboard/announcements/${announcement._id}`
                    }, {
                      default: _withCtx(() => [
                        _cache[15] || (_cache[15] = _createTextVNode(" View ")),
                        _createVNode(_component_ArrowRightIcon, { class: "ml-1 h-3 w-3" })
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("h3", _hoisted_35, [
              _createVNode(_component_CalendarDaysIcon, { class: "h-5 w-5 text-primary" }),
              _cache[16] || (_cache[16] = _createTextVNode(" Upcoming Events "))
            ]),
            _createVNode(_component_router_link, {
              class: "text-sm font-medium text-gray-900 inline-flex items-center gap-2 rounded-full bg-primary px-3 py-1",
              to: "/dashboard/events"
            }, {
              default: _withCtx(() => [
                _cache[17] || (_cache[17] = _createTextVNode(" View all ")),
                _createVNode(_component_ArrowRightIcon, { class: "h-4 w-4 text-gray-900" })
              ]),
              _: 1
            })
          ]),
          (_ctx.upcomingEvents.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " No events scheduled yet. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingEvents.slice(0, 3), (event) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: event._id,
                    class: "border border-gray-200 rounded-2xl p-3"
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_router_link, {
                        class: "text-sm font-medium text-gray-900 hover:text-primary",
                        to: `/dashboard/events/${event._id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(event.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(event.date)) + " ", 1),
                            (event.startTime || event.endTime)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, " • " + _toDisplayString(_ctx.formatTimeRange(event.startTime, event.endTime)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (event.location)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(event.location), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_42, [
                            (event.hidePrice)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Paid event"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.getEventPriceLabel(event)), 1)
                      ])
                    ]),
                    _createVNode(_component_router_link, {
                      class: "mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-3 py-2 text-xs font-semibold text-gray-900 hover:bg-[#c9ad99]",
                      to: `/dashboard/events/${event._id}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TicketIcon, { class: "h-4 w-4" }),
                        _cache[18] || (_cache[18] = _createTextVNode(" See event "))
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
        ])
      ]),
      (_ctx.isCommunityPlus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h3", _hoisted_48, [
                  _createVNode(_component_UserGroupIcon, { class: "h-5 w-5 text-primary" }),
                  _cache[19] || (_cache[19] = _createTextVNode(" Featured Members "))
                ]),
                _createVNode(_component_router_link, {
                  class: "text-sm font-medium text-gray-900 inline-flex items-center gap-2 rounded-full bg-primary px-3 py-1",
                  to: "/dashboard/directory"
                }, {
                  default: _withCtx(() => [
                    _cache[20] || (_cache[20] = _createTextVNode(" View directory ")),
                    _createVNode(_component_ArrowRightIcon, { class: "h-4 w-4 text-gray-900" })
                  ]),
                  _: 1
                })
              ]),
              (_ctx.users.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, " No members found. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users.slice(0, 4), (member) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: member._id,
                        class: "flex items-center justify-between"
                      }, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.getInitials(member.fullName || member.email)), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_53, _toDisplayString(member.fullName || 'Member'), 1),
                            _createElementVNode("div", _hoisted_54, _toDisplayString(member.company || member.email), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "text-xs font-medium text-gray-900 border border-gray-300 rounded-full px-3 py-1 hover:bg-gray-100 inline-flex items-center gap-1",
                          type: "button",
                          onClick: ($event: any) => (_ctx.toggleContact(member._id))
                        }, [
                          (!_ctx.isContact(member._id))
                            ? (_openBlock(), _createBlock(_component_UserPlusIcon, {
                                key: 0,
                                class: "h-3.5 w-3.5"
                              }))
                            : (_openBlock(), _createBlock(_component_CheckIcon, {
                                key: 1,
                                class: "h-3.5 w-3.5"
                              })),
                          _createTextVNode(" " + _toDisplayString(_ctx.isContact(member._id) ? 'Added' : 'Add'), 1)
                        ], 8, _hoisted_55)
                      ]))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("h3", _hoisted_58, [
                  _createVNode(_component_BookOpenIcon, { class: "h-5 w-5 text-primary" }),
                  _cache[21] || (_cache[21] = _createTextVNode(" Recommended Learning "))
                ]),
                _createVNode(_component_router_link, {
                  class: "text-sm font-medium text-gray-900 inline-flex items-center gap-2 rounded-full bg-primary px-3 py-1",
                  to: "/academy"
                }, {
                  default: _withCtx(() => [
                    _cache[22] || (_cache[22] = _createTextVNode(" View courses ")),
                    _createVNode(_component_ArrowRightIcon, { class: "h-4 w-4 text-gray-900" })
                  ]),
                  _: 1
                })
              ]),
              (_ctx.courses.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, " No courses available. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses.slice(0, 3), (course) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: course._id,
                        class: "flex items-center justify-between border border-gray-200 rounded-2xl p-3"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_61, _toDisplayString(course.title), 1),
                          _createElementVNode("div", _hoisted_62, _toDisplayString(course.modules.length) + " modules • " + _toDisplayString(_ctx.getTotalVideos(course)) + " videos ", 1)
                        ]),
                        _createVNode(_component_router_link, {
                          class: "text-xs font-medium text-primary inline-flex items-center",
                          to: `/dashboard/course/${course._id}`
                        }, {
                          default: _withCtx(() => [
                            _cache[23] || (_cache[23] = _createTextVNode(" Open ")),
                            _createVNode(_component_ArrowRightIcon, { class: "ml-1 h-3.5 w-3.5" })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}